import React, { useState } from "react";
// react component for creating dynamic tables
//import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { useHistory } from "react-router-dom";
// import ToolkitProvider, {
//   Search,
//   CSVExport,
// } from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import ReactBSAlert from "react-bootstrap-sweetalert";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
// import CardActions from "@material-ui/core/CardActions";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import dateFormat from "dateformat";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import tableComponentStyles from "assets/theme/views/admin/tables.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import {
  redirectToLogout,
  parseWashingFeatures,
  openInNewTab,
  zeroFill,
  getIsPickedFromLaundry
} from "common/SharedFn";
import {
  getLaundryOrderDetails,
  getPendingApprovalOrderRecords
} from "../../network/ApiAxios";
import { ArrowBack, Image } from "@material-ui/icons";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const useStylesTables = makeStyles(tableComponentStyles);

const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const LaundryOrderDetailsPage = (props) => {
  const classes = {
    ...useStyles(),
    ...useStylesButtons(),
    ...useStylesTables(),
  };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [order, setOrder] = useState();
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [statusList, setStatusList] = useState([]);
  const [pendingApprovalRecords, setPendingApprovalRecords] = useState([]);
  const [forceRefresh, setForceRefresh] = useState(false);
  
  const [id, setId] = useState();
  var currentOrderId = props.match.params.id;
  let history = useHistory();
  const mapRef = React.useRef(null);

  const tableCellHeadTableHeadClassesObj = {
    root: classes.tableCellRoot + " " + classes.tableCellRootHead,
  };


  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const tidyUpOrder = (order) => {
    order = parseWashingFeatures(order);
    order.placedOnText = dateFormat(
      new Date(order.placedOn),
      "d-mmm-yyyy hh:MM TT"
    );
    order.pickupDateText = dateFormat(new Date(order.pickupDate), "d-mmm-yyyy");
    order.dropoffDateText = dateFormat(
      new Date(order.dropoffDate),
      "d-mmm-yyyy"
    );
    order.pickupTimeslot = 
    order.pickupDateText +
        " " +
        order.availabilitySlotByPickupTimeslot.startTime +
        " - " +
        order.availabilitySlotByPickupTimeslot.endTime;
    setCurrentRecord(order);
    return order;
  };

  const setCurrentRecord = (info) => {
    const {
      id
    } = info;
    setId(id);
  };

  const clearCurrentRecord = () => {
    setId();
  };


  const accessTagQrsPage = (id) => {
    let history = createHistory();
    history.push("/admin/laundryOrders/tagQrs/" + id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const accessScanQrsPage = (id) => {
    let history = createHistory();
    history.push("/admin/laundryOrders/scanQrs/" + id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const fetchOrderDetails = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try {
      const response = await getLaundryOrderDetails(currentOrderId);
      const responsePendingApproval = await getPendingApprovalOrderRecords(currentOrderId);
      const { data } = response;
      if (data.result.isSuccess) {
        setOrder(tidyUpOrder(data.data));
        setPendingApprovalRecords(responsePendingApproval.data.data);
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch order details " + ex);
    }
    setIsLoading(false);
  };

  const getTableRow = (name, value) => {
    return (
      <TableRow>
        <TableCell style={{ fontSize: "16px", fontWeight: "bold" }}>
          {name}
        </TableCell>
        <TableCell style={{ fontSize: "16px" }}>{value}</TableCell>
      </TableRow>
    );
  };


  const getTableRowNotes = (name, value) => {
    return (
      <TableRow>
        <TableCell style={{ fontSize: "16px", fontWeight: "bold",color: "red" }}>
          {name}
        </TableCell>
        <TableCell style={{ fontSize: "16px" }}>{value}</TableCell>
      </TableRow>
    );
  };

  const getServiceTableRow = (img, name, weight, quantity, type) => {
    return (
      <TableRow>
        <TableCell>
          <img src={img} width="25px" />
        </TableCell>
        <TableCell style={{ fontSize: "16px", fontWeight: "bold" }}>
          {name}
        </TableCell>
        <TableCell style={{ fontSize: "16px" }}>{weight} kg</TableCell>
        <TableCell style={{ fontSize: "16px" }}>{quantity}</TableCell>
        <TableCell style={{ fontSize: "16px" }}>{type}</TableCell>
      </TableRow>
    );
  };

  const getLaundryTagTableRow = (img, name, tag, isAdditional, isPickedUp) => {
    return (
      <TableRow>
        <TableCell>
          <img src={img} width="25px" />
        </TableCell>
        <TableCell style={{ fontSize: "16px", fontWeight: "bold" }}>
          {name}
        </TableCell>
        <TableCell style={{ fontSize: "16px" }}>{tag}</TableCell>
        <TableCell style={{ fontSize: "16px" }}>{isAdditional}</TableCell>
        <TableCell style={{ fontSize: "16px" }}>{isPickedUp}</TableCell>
      </TableRow>
    );
  };

  const getSpecialRequestTableRow = (title, notes, img) => {
    return (
      <TableRow>
        <TableCell style={{ fontSize: "16px" }}>{title}</TableCell>
        <TableCell style={{ fontSize: "16px" }}>{notes}</TableCell>
        <TableCell>
          <div className="actions-right">
            <Tooltip title="View Image">
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={() => {
                  openInNewTab(img);
                }}
              >
                <Box component={Image} />
              </Button>
            </Tooltip>
          </div>
        </TableCell>
      </TableRow>
    );
  };

  const getLaundryPhotosTableRow = (notes, img) => {
    return (
      <TableRow>
        <TableCell style={{ fontSize: "16px" }}>{notes}</TableCell>
        <TableCell>
          <div className="actions-right">
            <Tooltip title="View Image">
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={() => {
                  openInNewTab(img);
                }}
              >
                <Box component={Image} />
              </Button>
            </Tooltip>
          </div>
        </TableCell>
      </TableRow>
    );
  };


  useAsyncEffect(async () => {
    fetchOrderDetails();
  }, [forceRefresh]);

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Tooltip title="Back">
                        <Button
                          size="small"
                          classes={{
                            root: classes.buttonContainedPrimary,
                          }}
                          variant="contained"
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Box component={ArrowBack} />
                        </Button>
                      </Tooltip>
                      <Box component="span">
                        Order #{order != null  ? order.publicId : currentOrderId}
                        <Grid
                          container
                          className="pl-4"
                          style={{
                            display: "inline-block",
                          }}
                        >{order != null && order.status === 3 ? (
                          order.orderBagUpdate != null && order.orderBagUpdate.status === 1 ? (
                            // Render component if conditions are met
                            <Tooltip title="Mark as Washing" style={{ margin: "5px" }}>
                              <Button
                                variant="contained"
                                size="small"
                                classes={{
                                  root: classes.buttonContainedWarning,
                                }}
                                onClick={() => {
                                  accessScanQrsPage(currentOrderId);
                                }}
                              >
                                <span>Mark as Washing</span>
                              </Button>
                            </Tooltip>
                          ) : (
                            // Render alternative message if orderBagUpdate status is not 1
                            <div>
                              <Tooltip title="Cannot Mark as Washing" style={{ margin: "5px" }}>
                              <Button
                                variant="contained"
                                size="small"
                                classes={{
                                  root: classes.buttonContainedIssue,
                                }}
                              >
                                <span>To mark this order as Washing, Approve previous order update!</span>
                              </Button>
                            </Tooltip>
                              </div>
                          )
                        ) : (
                          // Render alternative message if order status is not 3
                          <div></div>
                        )}
                          {(order != null && order.status == 4) ? (<Tooltip
                            title="Tag QRs and Mark as Washed"
                            style={{ margin: "5px" }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              classes={{
                                root: classes.buttonContainedSuccess,
                              }}
                              onClick={() => {
                                accessTagQrsPage(currentOrderId);
                              }}
                            >
                              <span>Tag Qr Codes and Mark as Washed</span>
                            </Button>
                          </Tooltip>) : (<div></div>)}
                        </Grid>
                      </Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>

              {isLoading || order == null ? (
                <Box
                  component={Grid}
                  container
                  justifyContent="center"
                  className="justify-content-center"
                >
                  <div className="text-center" style={{ width: "20%" }}>
                    <LoadingAnimation />{" "}
                  </div>
                </Box>
              ) : (
                <>
                  <Grid container>
                    <Grid item xs={12}>
                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Order Info</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>

                        <Grid container justify="space-between">
                          <Grid item xs={12} sm={12} md={6}>
                            <TableContainer
                              style={{
                                paddingLeft: "26px",
                                paddingRight: "26px",
                              }}
                            >
                              <Box
                                component={Table}
                                alignItems="center"
                                marginBottom="0!important"
                              >
                                {getTableRow("Order ID", order.publicId)}
                                {getTableRow(
                                  "Customer ID",
                                  "C"+zeroFill(order.userId,5)
                                )}
                                {getTableRow(
                                  "Drop Off In Laundry By",
                                  order.pickupDateText +
                                    " " +
                                    order.availabilitySlotByPickupTimeslot
                                      .startTime +
                                    " - " +
                                    order.availabilitySlotByPickupTimeslot
                                      .endTime
                                )}
                                {getTableRow(
                                  "Assigned Pickup Driver",
                                  order.driverByAssignedDriver != null
                                    ? order.driverByAssignedDriver.fullNameEn
                                    : ""
                                )}
                              </Box>
                            </TableContainer>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6}>
                            <TableContainer
                              style={{
                                paddingLeft: "26px",
                                paddingRight: "26px",
                              }}
                            >
                              <Box
                                component={Table}
                                alignItems="center"
                                marginBottom="0!important"
                              >
                              {getTableRow(
                                "Status",
                                order.statusTextByStatus.textEn + (order.status > 3 ? getIsPickedFromLaundry(order) ? " (Picked from Laundry)" : " (Not Picked from Laundry Yet)" : "")
                              )}
                              {getTableRow(
                                "Assigned Laundry",
                                order.laundryByAssignedLaundry != null
                                  ? order.laundryByAssignedLaundry.name
                                  : ""
                              )}
                                {getTableRow(
                                  "Pick Up From Laundry Before",
                                  order.dropoffDateText +
                                    " " +
                                    order.availabilitySlotByDropoffTimeslot
                                      .startTime +
                                    " - " +
                                    order.availabilitySlotByDropoffTimeslot
                                      .endTime
                                )}
                                {getTableRow(
                                  "Assigned Dropoff Driver",
                                  order.driverByAssignedDriverDropoff != null
                                    ? order.driverByAssignedDriverDropoff.fullNameEn
                                    : ""
                                )}
                              </Box>
                            </TableContainer>
                          </Grid>

                          {/* {order.portalNotes != null ?<TableContainer
                              style={{
                                paddingLeft: "39px",
                                paddingRight: "39px",
                              }}
                            >
                          {getTableRowNotes(
                                  "Order Level Notes",
                                  order.portalNotes
                                )}
                                </TableContainer> : ""} */}
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                  <Grid container justify="space-between">
                    <Grid item xs={12} sm={12} md={6}>
                    {order.subscriptionId == null ? (<Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Ordered Services</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Image
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Service
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Quantity
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Type
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.orderServicesById.map(function (
                                service,
                                i
                              ) {
                                return getServiceTableRow(
                                  service.serviceByServiceId.imageUrl,
                                  service.serviceByServiceId.nameEn,
                                  service.quantity,
                                  service.serviceByServiceId.isPerItem === 0
                                    ? "Pay Per Bag"
                                    : "Pay Per Item"
                                );
                              })}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card>) : ''}
                      {/* <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Order Status History</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Status
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  DateTime
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.orderStatusHistoriesById.map(function (
                                status,
                                i
                              ) {
                                return getTableRow(
                                  status.statusTextByStatus.textEn,
                                  dateFormat(
                                    new Date(status.onDatetime),
                                    "d-mmm-yyyy hh:MM TT"
                                  )
                                );
                              })}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card> */}

                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Pickup/Driver Tags</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Image
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Service
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Weight
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Tag
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Is Additional
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.qrTagsById.map(function (
                                qrTag,
                                i
                              ) {
                                if(qrTag.flow == 1){
                                  return '';
                                }
                                return getServiceTableRow(
                                  qrTag.serviceByServiceId.bagImageUrl,
                                  qrTag.serviceByServiceId.nameEn,
                                  qrTag.weight,
                                  qrTag.tag,
                                  qrTag.isAdditional == 1
                                    ? "Yes"
                                    : "No"
                                );
                              })}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card>

                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Dropoff/Laundry Tags</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Image
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Service
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Tag
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Is Additional
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Is Picked Up
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.qrTagsById.map(function (
                                qrTag,
                                i
                              ) {
                                if(qrTag.flow == 0){
                                  return '';
                                }
                                return getLaundryTagTableRow(
                                  qrTag.serviceByServiceId.bagImageUrl,
                                  qrTag.serviceByServiceId.nameEn,
                                  qrTag.tag,
                                  qrTag.isAdditional == 1
                                    ? "Yes"
                                    : "No",
                                  qrTag.isPickedUp == 1
                                      ? "Yes"
                                      : "No"
                                );
                              })}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card>
                              </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                    {pendingApprovalRecords != null && pendingApprovalRecords.length>0 ? (<Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Pending Approval Updates</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        
                        {pendingApprovalRecords.map(function (
                                pendingApprovalRecord,
                                i
                              ) {
                                return (<TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <br/>Pending Changes<br/>
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Image
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Service
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Quantity
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Type
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {pendingApprovalRecord.orderBagUpdateServiceRecordDtos.map(function (
                                service,
                                j
                              ) {
                                if(service.newQuantity !== 0){
                                  return getServiceTableRow(
                                    service.service.imageUrl,
                                    service.service.nameEn,
                                    service.newQuantity,
                                    service.service.isPerItem === 0
                                      ? "Pay Per Bag"
                                      : "Pay Per Item"
                                  );
                                }
                              })}
                            </TableBody>
                          </Box>
                        </TableContainer>);})}
                      </Card> ) : ''}
                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Special Requests</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            {getTableRow("Scent", order.scent)}
                            {getTableRow("Starch", order.starch)}
                            {/* {getTableRow(
                              "Thobe Back Crease",
                              order.thobeBackCrease 
                            )}*/}
                            {getTableRow("Ghetra Type + Starch", order.ghetra)}
                            {/* {getTableRow(
                              "Shirts Sleeve Crease",
                              order.shirtsSleeveCrease
                            )}
                            {getTableRow(
                              "Pants Travelers Crease",
                              order.pantsTravelersCrease
                            )} */}
                            {getTableRow(
                              "Notes",
                              order.notes
                            )}
                            {getTableRowNotes(
                                  "Order Level Notes",
                                  order.portalNotes
                                )}
                          </Box>
                        </TableContainer>
                      </Card>
                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">
                                Special Requests - Notes/Images
                              </Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Title
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Notes
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Actions
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.orderSpecialRequestPhotosById.map(
                                function (sr, i) {
                                  return getSpecialRequestTableRow(
                                    sr.title,
                                    sr.notes,
                                    sr.photoUrl
                                  );
                                }
                              )}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card>



                      {/* <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">
                                Laundry Photos
                              </Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Datetime
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Actions
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.orderLaundryPhotosById.map(
                                function (op, i) {
                                  return getLaundryPhotosTableRow(
                                    dateFormat(
                                      new Date(op.addedOn),
                                      "d-mmm-yyyy hh:MM TT"
                                    ),
                                    op.photoUrl
                                  );
                                }
                              )}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card> */}
                    
                    </Grid>
                  </Grid>
                </>
              )}
            </Card>
          </Grid>
        </Grid>

        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default LaundryOrderDetailsPage;
